const isBoolean = (_) => {
  return typeof _ === "boolean";
};

export { isBoolean };
